import React, { useState, useEffect } from 'react';
import { TabsComponent } from '../../../../Components';
import { GlobalTranslate } from '../../../../Helper';
import { tabsPermissionsHelper } from '../../../../Helper/ExceptionPermissions.Helper';
import { useTitle } from '../../../../Hooks';
import { ExternalDashboardTabs } from '../ExternalDashboardTabs/ExternalDashboardTabs';

export const ExternalDashboard = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [dashboardTabsList, setDashboardTabsList] = useState([]);
  useTitle(GlobalTranslate.t('Dashboard:external-dashboard'));
  const onTabChanged = (e, newTap) => {
    setActiveTab(newTap);
  };

  useEffect(() => {
    const list = tabsPermissionsHelper(ExternalDashboardTabs).map((field, fieldIndex) => ({
      ...field,
      index: fieldIndex,
    }));
    setDashboardTabsList(list);
  }, [ExternalDashboardTabs]);

  return (
    <div>
      <TabsComponent
        data={dashboardTabsList}
        labelInput='label'
        themeClasses='theme-curvedpowerbi'
        currentTab={activeTab}
        onTabChanged={onTabChanged}
        dynamicComponentProps={{
          setActiveTab,
          dynamicComponentExternalProps: Object.values(dashboardTabsList).find(
            (element) => element.index === activeTab
          ),
        }}
      />
    </div>
  );
};
